import React from 'react'
import { useParams } from 'react-router-dom'
import { StringParam, useQueryParams } from 'use-query-params'
import { jwtDecode, JwtPayload } from 'jwt-decode'
import { HttpStatus } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// types
import { ContextProps, MyReservationPageQueryType } from '../types/types'

// components
import MyReservationPage from '../pages/MyReservationPage/MyReservationPage'

// utils
import { getValidMyReservationPageQuery } from '../utils/helper'
import { TOKEN_AUD } from '../utils/enums'

type MyReservationRouteParams = {
	reservationID: string
}

const MyReservationRoute: React.FC<React.PropsWithChildren<ContextProps>> = (props) => {
	const { reservationID } = useParams<MyReservationRouteParams>()

	// NOTE: when adding new parameter, also add it to MyReservationPageQueryType and MyReservationPageSetQueryType in interfaces
	const [query, setQuery] = useQueryParams({
		t: StringParam
	})

	const validQuery = getValidMyReservationPageQuery(query as MyReservationPageQueryType)

	if (!props.isAuthorized) {
		let validToken

		try {
			if (validQuery.t) {
				const decodedToken = jwtDecode<JwtPayload>(validQuery.t)
				if (decodedToken.aud === TOKEN_AUD.CANCEL_RESERVATION) {
					validToken = validQuery.t
				}
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error(e)
		}

		if (!validToken) {
			return (
				<HttpStatus status={404} {...props}>
					{null}
				</HttpStatus>
			)
		}
	}

	return <MyReservationPage reservationID={reservationID as string} query={validQuery} setQuery={setQuery} {...props} />
}

export default MyReservationRoute
